import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../../utils/axios.js"; 

export const useFriendRequests = () => {
    const queryClient = useQueryClient();

    const { isLoading, error, data: requests } = useQuery({
        queryKey: ["friendRequests"],
        queryFn: () => makeRequest.get("/friendships/requests").then((res) => res.data),
    });

    const acceptMutation = useMutation({
        mutationFn: (senderId) => {
            return makeRequest.put("/friendships/confirm", { userId: senderId });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["friendRequests"] });
            queryClient.invalidateQueries({ queryKey: ["friends"] });
        },
    });

    const deleteMutation = useMutation({
        mutationFn: (senderId) => {
            return makeRequest.delete(`/friendships?userId=${senderId}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["friendRequests"] });
        },
    });

    return {
        requests,
        isLoading,
        error,
        acceptRequest: acceptMutation.mutate,
        deleteRequest: deleteMutation.mutate,
        isAccepting: acceptMutation.isPending || acceptMutation.isLoading,
        isDeleting: deleteMutation.isPending || deleteMutation.isLoading,
    };
};